import React, { useEffect } from "react";
import DoctorCard from "../../common-components/doctor_card/DoctorCard";
import "./GetExpertAdvice.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllDoctors } from "../../../features/doctor/doctorSlice";
const data = [
  {
    id: 1,
    image: "/assets/images/home/dr/img1.png",
    category: "Ayurvedic",
    name: "Dr. Amit Sharma",
    hospital: "City Care Hospital, Pune",
  },
  {
    id: 2,
    image: "/assets/images/home/dr/img2.png",
    category: "Homeopathy",
    name: "Dr. Aditya Jagtap",
    hospital: "Healing Touch Clinic, Mumbai",
  },
  {
    id: 3,
    image: "/assets/images/home/dr/img3.png",
    category: "General Physician",
    name: "Dr. Sakshi Awhad",
    hospital: "LifeCare Hospital, Delhi",
  },
  {
    id: 4,
    image: "/assets/images/home/dr/img1.png",
    category: "General Physician",
    name: "Dr. Amit Sharma",
    hospital: "City Care Hospital, Pune",
  },
];

export default function GetExpertAdvice() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const allDoctors = useSelector((state) => state.doctor.allDoctors);

  useEffect(() => {
    dispatch(getAllDoctors({}));
  }, [dispatch]);
  return (
    <section className="Category_section GetExpertAdvice-section ">
      <div className="container">
        <div className="heading_holder">
          <h4 className="heading_text">Get Expert Advice Today</h4>
          <Green_btn
            btnText="View all"
            onClick={() => navigate("/doctor-consultation")}
          />
        </div>

        <div className="cat_subcat_div">
          <div className="row inner-padding g-4 ">
            {allDoctors?.data?.map((item) => (
              <div
                key={item.id}
                className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 card-wrapper"
              >
                {" "}
                <DoctorCard
                  id={item?.id}
                  image={process.env.REACT_APP_IMG_URL + item.image}
                  category={item.category}
                  name={
                    `${item.Doctor_Detail?.doctor_code || ""} ${item.name ||
                      ""}` || ""
                  }
                  hospital={item.Doctor_Detail?.hospital_name || ""}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
